import { CommonBridgeEngine } from './commonBridgeEngine';
export class WorkerBridgeImpl extends CommonBridgeEngine {
    ping(params) {
        return this.renderChannelApi.invoke({
            eventName: 'ping',
            params,
        });
    }
    async returnTaskResult(params) {
        const list = (await this.renderChannelApi.invoke({
            eventName: 'returnTaskResult',
            params,
        }));
        return list.data;
    }
}
